import { NgModule } from '@angular/core';
import { AngularOpenStreetComponent } from './components/angular-open-street/angular-open-street.component';



@NgModule({
  declarations: [AngularOpenStreetComponent],
  imports: [
  ],
  exports: [AngularOpenStreetComponent]
})
export class AngularOpenStreetModule { }
